<template>
    <span>
        <component v-for="s in skladowe" :is="s.sub ? 'sub' : 'span'" :key="s.id">{{s.text}}</component>
    </span>
</template>
<script>
export default {
    name: 'chemical',
    props: {
        value: String
    },
    data : function() {        
        return {
            id: 0, 
            skladowe : []
        }
    },
    mounted() { 
        let isChar = (char) => {
            return char.toLowerCase() !== char.toUpperCase();
        }
        let isNumber = (char) => {
            return (char === parseInt(char, 10).toString());
        }
        let change = (txt) => {
            return txt
                .replace("MG", "Mg")
                .replace("CU", "Cu")
                .replace("CA", "Ca")
                .replace("CL", "Cl");
        }
        var text = this.value; 
        var out = "";
        var last = "";
        var char = "";
        for (var i = 0; i < text.length; i++) {
            last = char;
            char = text.charAt(i);
            if (isChar(last) && isNumber(char)){
                if (out != "") {
                    this.skladowe.push({text: change(out), sub: false, id: this.id++ });
                    out = "";
                }
                this.skladowe.push({text: char, sub: true, id: this.id++ });
            }
            else
                out += char.toUpperCase();
        }
        if (out != "")
            this.skladowe.push({text: change(out), sub: false, id: this.id++ });

    }
}
</script>